export default __webpack_public_path__ + "static/media/loginEmptyState.56b7662b.svg";